import { useState } from "react";
import { ChoiceField, NumField } from "@/components/tool/CalcFields";
import { SciStatGrid } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";

const SIDES = [4, 6, 8, 10, 12, 20];
const PIPS = ["", "⚀", "⚁", "⚂", "⚃", "⚄", "⚅"];

function roll(count: number, sides: number): number[] {
  return Array.from(
    { length: count },
    () => 1 + Math.floor(Math.random() * sides),
  );
}

export function DiceRoller() {
  const [count, setCount] = useState("2");
  const [sides, setSides] = useState(6);
  const [rolls, setRolls] = useState<number[]>(() => [3, 5]);

  const n = Math.min(20, Math.max(1, Math.floor(Number(count)) || 1));
  const total = rolls.reduce((a, b) => a + b, 0);

  return (
    <div className="sci-card rounded-2xl space-y-4 p-6 sm:p-8">
      <div className="grid gap-4 sm:grid-cols-2">
        <NumField
          id="count"
          label={m.dice_count()}
          value={count}
          onChange={setCount}
        />
        <ChoiceField
          label={m.dice_sides()}
          value={String(sides)}
          onChange={(v) => setSides(Number(v))}
          options={SIDES.map((s) => ({ value: String(s), label: `d${s}` }))}
        />
      </div>

      <button
        type="button"
        onClick={() => setRolls(roll(n, sides))}
        className="sci-result-zone sci-result w-full rounded-md px-5 py-3 text-sm font-semibold"
      >
        {m.dice_roll()}
      </button>

      <div
        data-testid="dice-faces"
        className="flex flex-wrap items-center justify-center gap-3"
      >
        {rolls.map((r, i) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: positional dice faces
            key={i}
            className="flex h-14 w-14 items-center justify-center rounded-xl border border-black/10 text-3xl"
            title={`${r}`}
          >
            {sides === 6 ? PIPS[r] : r}
          </span>
        ))}
      </div>

      <SciStatGrid
        items={[
          { label: m.dice_total(), value: String(total) },
          { label: m.dice_dice(), value: `${rolls.length} × d${sides}` },
        ]}
      />
    </div>
  );
}
